import { QueryFunctionContext } from "@tanstack/react-query";

type ApiQueryKey = ["GET", string] | ["GET", string, { query: Record<string, string> }];

const API_ORIGIN = import.meta.env.VITE_ENV_API_ORIGIN;

if (!API_ORIGIN) {
  throw new Error("Missing API_ORIGIN");
}

export default async function fetchApi({ queryKey }: QueryFunctionContext<ApiQueryKey>) {
  const [method, path, options] = queryKey;
  const { query } = options ?? { query: {} };
  console.log({ API_ORIGIN, method, path, options, query });

  const url = new URL(path, API_ORIGIN);
  Object.entries(query).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  console.log({ url, method });
  const response = await fetch(url, { method });
  console.log({ response });
  if (!response.ok) {
    throw new Error(`Network response was ${response.status}: ${response.statusText}`);
  }
  return response.json();
}
